var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:['social-button', _vm.classes()],attrs:{"href":this[this.for].url,"target":"_blank"}},[_c('v-icon',[_vm._v(_vm._s(this[this.for].icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }